import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const TermsAndConditions = () => {
  const effectiveDate = "May 20, 2025";
  const businessName = "SalonLogic";
  const contactEmail = "support@salonpricingcalculator.co.uk";

  return (
    <div className="legal-page-container">
      <div className="legal-page">
        <h1>Terms and Conditions</h1>
        <p className="effective-date"><strong>Effective from: {effectiveDate}</strong></p>

        <p>Please read these Terms and Conditions carefully before using the Salon Pricing Calculator.</p>

        <h2>1. Agreement to Terms</h2>
        <p>
          By accessing or using salonpricingcalculator.co.uk ("Website"), you agree to be bound by these Terms and our Privacy Policy.
          If you do not agree with any part of the terms, please do not use this Website or any of our tools or services.
        </p>

        <h2>2. Subscriptions</h2>
        <p>Some features of the calculator require a paid subscription. By subscribing, you agree to:</p>
        <ul>
          <li>Provide accurate and complete payment details</li>
          <li>Pay all charges shown at the time of checkout</li>
          <li>Pay any applicable taxes in addition to the listed price</li>
        </ul>

        <h2>3. Refund Policy</h2>
        <p>
         As this is a digital product with immediate access, all sales are final. By completing your purchase, you confirm that you waive your statutory 14-day cooling-off period under the Consumer Contracts Regulations.
        </p>

        <h2>4. User Accounts</h2>
        <p>
          You must provide accurate and complete information when registering. You are responsible for maintaining the confidentiality of your login credentials.
          We are not liable for any loss or damage arising from your failure to protect your account.
        </p>

        <h2>5. Intellectual Property</h2>
        <p>
          The Website and its content, including tools, features, logic, and resources, are the intellectual property of {businessName} and protected by applicable laws.
          Nothing may be copied, reproduced, republished, sold, or exploited without express written permission.
        </p>

        <h2>6. Copyright and Usage</h2>
        <p>
          You are granted a non-exclusive, non-transferable licence to use the calculator for your personal or business use only.
          Redistribution, resale, or reverse-engineering of the tool or its outputs is strictly prohibited.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>{businessName} will not be liable for any indirect, incidental, or consequential losses, including but not limited to:</p>
        <ul>
          <li>Loss of profits, revenue, or data</li>
          <li>Errors or inaccuracies in pricing results</li>
          <li>Business outcomes resulting from the use of the calculator</li>
        </ul>

        <h2>8. Disclaimer of Results</h2>
        <p>
          The calculator is a guidance tool. Results depend on the accuracy of your inputs and your business implementation.
          We do not guarantee financial performance or profitability outcomes.
        </p>

        <h2>9. Termination</h2>
        <p>
          We reserve the right to suspend or terminate access to the service without notice for any breach of these Terms.
          You may cancel your subscription at any time through your account settings.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These Terms are governed by and construed in accordance with the laws of the United Kingdom. Any disputes shall be subject to the exclusive jurisdiction of the UK courts.
        </p>

        <h2>11. Changes to Terms</h2>
        <p>
          We may revise these Terms at any time. When we do, we will update the effective date. Continued use of the Website after changes constitutes your acceptance of those changes.
        </p>

        <h2>12. Data Protection & Privacy</h2>
        <p>
          We process your data in accordance with UK GDPR. Please review our <Link to="/privacy-policy">Privacy Policy</Link> for details on how your information is collected and used.
        </p>

        <h2>13. Contact Us</h2>
        <p>If you have any questions, please contact us at <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.</p>

        <div className="legal-footer">
          <Link to="/">Return to Dashboard</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
